<template>
  <packing ref="packing" :device="device" :query-param="queryParam"/>
</template>

<script>
import Packing from '@/views/outbound/pack_template/Packing.vue'

export default {
  components: { Packing },
  props: {
    queryParam: { type: Object, default: null }
  },
  data() {
    return {
      device: false
    }
  }
}
</script>